import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { catchError, finalize, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { EInterventionType } from '../domain/planning/enum/intervention-type';
import { SANDRETaxionModel } from '../models/SANDRE-taxon-model';
import { CoreData } from '../tools/core-data';
import { LoadingTask } from '../tools/loading-task';
import { BaseService } from './base-service';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable({
    providedIn: 'root'
})
export class SANDREService extends BaseService {
    private serviceUrl = `${environment.serviceMainBaseUrl}api/sandre`;

    constructor(
        protected http: HttpClient,
        protected coreData: CoreData,
        protected loadingTask: LoadingTask,
        protected snackBare: MatSnackBar,
        protected router: Router,
        ) {
            super(coreData, router, snackBare);
    }

    getTaxonList(type: EInterventionType, filter: string) {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/Taxon/${type}?filter=${encodeURI(filter)}`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getSANDRETaxon')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: SANDRETaxionModel[]) => {
                return response.map((item: SANDRETaxionModel) => {
                    return SANDRETaxionModel.mapFromJSON(item);
                });
            }));
    }

    getIBMRTaxonList() {
        this.loadingTask.activateLoading();
        return this.http.get(`${this.serviceUrl}/IBMRTaxon/`, this.generateHeader()).pipe(
            catchError(this.handleError<any>('getIBMRTaxonList')),
            finalize(() => this.loadingTask.deactivateLoading()),
            map((response: SANDRETaxionModel[]) => {
                return response.map((item: SANDRETaxionModel) => {
                    return SANDRETaxionModel.mapFromJSON(item);
                });
            }));
    }
}
